<script setup>
import { ref } from 'vue'

const reasons = ref([
  {
    icon: 'fa-sack-dollar',
    title: 'Avoid Penalties',
    description:
      'Beat the deadline with our efficient BOIR filing service. We ensure your report is submitted on time, helping you avoid potential legal complications and penalties.'
  },
  {
    icon: 'fa-shield-check',
    title: 'Stay Compliant',
    description:
      'Filing requirements are hard to remember. Our team of experts does the heavy lifting so you can stay focused on running your business.'
  },
  {
    icon: 'fa-message-dollar',
    title: 'No Hidden Fees',
    description:
      'We stand by our transparent pricing and will never surprise you with hidden fees or unwanted upsells. One simple price for all of your compliance needs.'
  }
])
</script>

<template>
  <div class="container mb-9">
    <span class="text-cap divider-center mb-5">Why Use ComplianceClerk?</span>
    <div class="text-center mx-md-auto mb-5 mb-md-9 w-lg-50">
      <p class="h3">
        Our easy and accurate report filing can help reduce the risk of not
        satisfying federal mandates.
      </p>
    </div>

    <div class="row mb-0">
      <div
        class="col-sm-12 col-md-4 mb-2 mb-sm-3"
        v-for="(reason, index) in reasons"
        :key="index"
      >
        <div class="d-flex align-items-center mb-4">
          <div class="flex-shrink-0">
            <span class="svg-icon svg-icon-lg text-primary">
              <i class="fa-duotone fa-2xl fa-solid" :class="reason.icon"></i>
            </span>
          </div>
          <div class="flex-grow-1 ms-3">
            <h4 class="mb-0">{{ reason.title }}</h4>
          </div>
        </div>
        <p>{{ reason.description }}</p>
      </div>
    </div>

    <div class="text-center">
      <div class="d-grid justify-content-md-center gap-2 mb-3">
        <button
          class="btn btn-primary btn-transition"
          @click="$emit('get-started')"
        >
          Get Started
        </button>
      </div>
      <p class="small">Secure, compliant, and hassle-free BOIR filing.</p>
    </div>
  </div>
</template>
